import React from 'react';
import './pageloader.css';

const PageLoader = () => {
  return (
    <div className="page-loader-overlay">
      <div className="page-loader">
        <div className="loader-content">
          <div className="loader-spinner">
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
          </div>
          <div className="loader-text">
            <h3>Mezopit</h3>
            <p>Yükleniyor...</p>
          </div>
          <div className="loader-progress">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>
        </div>
        <div className="loader-footer">
          <span className="loader-tagline">İnovasyon & Teknoloji Çözümleri</span>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;